var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdmoApprovalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_283_7577)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_283_7577",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 15.3269 19.3269 1 37 1C54.6731 1 69 15.3269 69 33C69 50.6731 54.6731 65 37 65C19.3269 65 5 50.6731 5 33Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 15.3269 19.3269 1 37 1C54.6731 1 69 15.3269 69 33C69 50.6731 54.6731 65 37 65C19.3269 65 5 50.6731 5 33Z",
    fill: "#FFFBEB",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 33M69 33M69 33M5 33M37 1M69 33M37 65M5 33M37 65V63C20.4315 63 7 49.5685 7 33H5H3C3 51.7777 18.2223 67 37 67V65ZM69 33H67C67 49.5685 53.5685 63 37 63V65V67C55.7777 67 71 51.7777 71 33H69ZM37 1V3C53.5685 3 67 16.4315 67 33H69H71C71 14.2223 55.7777 -1 37 -1V1ZM37 1V-1C18.2223 -1 3 14.2223 3 33H5H7C7 16.4315 20.4315 3 37 3V1Z",
    fill: "#D97706",
    mask: "url(#path-1-inside-1_283_7577)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 23H31C30.4696 23 29.9609 23.2107 29.5858 23.5858C29.2107 23.9609 29 24.4696 29 25V41C29 41.5304 29.2107 42.0391 29.5858 42.4142C29.9609 42.7893 30.4696 43 31 43H43C43.5304 43 44.0391 42.7893 44.4142 42.4142C44.7893 42.0391 45 41.5304 45 41V28L40 23Z",
    stroke: "#D97706",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 23V27C39 27.5304 39.2107 28.0391 39.5858 28.4142C39.9609 28.7893 40.4696 29 41 29H45",
    stroke: "#D97706",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 30H33",
    stroke: "#D97706",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 34H33",
    stroke: "#D97706",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 38H33",
    stroke: "#D97706",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_283_7577",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_283_7577"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_283_7577"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_283_7577"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_283_7577",
    result: "effect2_dropShadow_283_7577"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_283_7577",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdmoApprovalIcon);
export default __webpack_public_path__ + "static/media/cdmo-Approval-icon.cd264f21c06ac7c39c8e612c50a04771.svg";
export { ForwardRef as ReactComponent };